<template>
  <v-container>
    <h1>{{ show.name }} - {{ person.first_name }} {{ person.last_name }}</h1>
    <h2>Eventi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Data inizio</th>
            <th>Data fine</th>
            <th>Tipo</th>
            <th>Luogo</th>
            <th>Programma</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in filteredEvents" :key="event.id">
            <td>
              {{ $formatDate($parseDate(event.start_date), "d MMMM y, H:mm") }}
            </td>
            <td>
              {{ $formatDate($parseDate(event.end_date), "d MMMM y, H:mm") }}
            </td>
            <td>{{ eventKinds[event.kind] }}</td>
            <td>
              {{
                get(
                  showPlaces.find((p) => p.id === event.place),
                  "place__name"
                )
              }}
            </td>
            <td>
              {{
                get(
                  concerts.find((c) => c.id === event.concert),
                  "short_title"
                )
              }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <h2 class="mt-8">Luoghi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Luogo</th>
            <th>Referente</th>
            <th>Contatto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="showPlace in filteredShowPlaces" :key="showPlace.id">
            <td>
              {{ showPlace.place__name }}
            </td>
            <td>{{ showPlace.internal_referent__name }}</td>
            <td>
              {{ showPlace.contact }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <h2 class="mt-8">Programmi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Concerto</th>
            <th>Gruppi</th>
            <th>Artisti</th>
            <th>Descrizione</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="concert in filteredConcerts" :key="concert.id">
            <td>
              {{ concert.short_title }}
            </td>
            <td>
              <template v-for="bandId in concert.bands">
                {{
                  get(
                    showBands.find((p) => p.id === bandId),
                    "band__name"
                  )
                }},
              </template>
            </td>
            <td>
              <template v-for="personId in concert.people">
                {{
                  get(
                    showPeople.find((p) => p.id === personId),
                    "person__name"
                  )
                }},
              </template>
            </td>
            <td>{{ concert.description }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <p style="margin-top: 20px;">
      Info:
      <br />
      Alfredo Bruno - Tel: +393761223166 - Mail:
      directorassistant@oficinaocm.com
      <br />
      Sofia Andreoli - Tel: +393892113471 - Mail:
      directorassistant@oficinaocm.com
      <br />
      <!-- Info travel/accomodation: Kati Gerola - Tel: +393517701823 - Mail:
      welcome@oficinaocm.com -->
    </p>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      eventKinds: {
        1: "evento pubblico",
        2: "prova",
        3: "accordatura",
      },
    }
  },
  computed: {
    showFk() {
      return this.$route.params.id
    },
    personFk() {
      return this.$route.params.personId
    },
    showPersonFk() {
      return this.$route.params.showPersonId
    },
    filteredEvents() {
      return this.events.filter((event) => {
        return event.people.includes(parseInt(this.showPersonFk))
      })
    },
    filteredShowPlaces() {
      // get all places from the events
      const ids = this.filteredEvents
        .map((e) => e.place)
        // get their unique ids
        .filter((v, i, a) => a.indexOf(v) === i)

      // map ids to showPlaces
      return ids.map((id) => this.showPlaces.find((p) => p.id === id))
    },
    filteredConcerts() {
      // get all concerts from the events
      const ids = this.filteredEvents
        .map((e) => e.concert)
        // get their unique ids
        .filter((v, i, a) => a.indexOf(v) === i)

      // map ids to concerts
      return ids.map((id) => this.concerts.find((p) => p.id === id))
    },
    ...mapState({
      loading(state) {
        return (
          state.events.pending.allEvents &&
          state.shows.pending.allConcerts &&
          state.shows.pending.allShowPlaces &&
          state.shows.pending.show
        )
      },
      events(state) {
        return state.events.allEvents
      },
      concerts(state) {
        return state.concerts.allConcerts
      },
      showPeople(state) {
        return state.shows.allShowPeople
      },
      showBands(state) {
        return state.shows.allShowBands
      },
      showPlaces(state) {
        return state.shows.allShowPlaces
      },
      person(state) {
        return state.people.person
      },
      show(state) {
        return state.shows.show
      },
    }),
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch("listAllEvents", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllConcerts", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllShowPlaces", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllShowPeople", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllShowBands", {
        params: { show: this.showFk },
      })
      this.$store.dispatch(`retrievePerson`, {
        params: { id: this.personFk },
      })
      this.$store.dispatch(`retrieveShow`, {
        params: { id: this.showFk },
      })
    },
  },
}
</script>
